"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _isNull = _interopRequireDefault(require("lodash/isNull"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _pick = _interopRequireDefault(require("lodash/pick"));

var _clientErrorLogger = _interopRequireDefault(require("../../util/clientErrorLogger"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _extend = _interopRequireDefault(require("lodash/extend"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _trim = _interopRequireDefault(require("lodash/trim"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CustomError = _interopRequireDefault(require("../components/form/CustomError"));

var _CustomForm = require("../components/form/CustomForm");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

// superclass must be a subclass of React.Component and must not implement the lifecycle methods defined below
var FormField = function FormField(superclass) {
  var _class, _descriptor, _descriptor2, _class2;

  return (0, _mobxReact.observer)((_class = (_class2 = /*#__PURE__*/function (_superclass) {
    _inherits(_class, _superclass);

    var _super = _createSuper(_class);

    function _class() {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this);

      _initializerDefineProperty(_assertThisInitialized(_this), "focused", _descriptor, _assertThisInitialized(_this));

      _initializerDefineProperty(_assertThisInitialized(_this), "value", _descriptor2, _assertThisInitialized(_this));

      _this.focused = false;
      _this.value = "";
      return _this;
    }

    _createClass(_class, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        // Check for changes to props that could impact the backing value, namely inConverters and outConverters
        var backingValue = this.formModel.get(prevProps.fieldName);

        if (backingValue !== this.value && (prevProps.inConverter !== this.props.inConverter || prevProps.outConverter !== this.props.outConverter)) {
          this.value = this.readBackingValue(this.props, true);
        }
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        this.value = this.readBackingValue(this.props); // If using the back/forward browser buttons the inputs may be pre-filled, so we need to
        // sync up the data as soon as possible. Well, not quite as soon as possible: we need to let
        // the parent's componentDidMount get called first so that all its listeners will be added.

        this._watchForSilentChangesTimeout = setTimeout(this.checkForUncontrolledChanges, 0);
        var formEmitter = this.formModel.emitter;

        if (formEmitter) {
          formEmitter.on("WATCH_FOR_UNCONTROLLED_CHANGES", this.setSilentChangeWatcherTimeout);
          formEmitter.on("STOP_WATCHING_FOR_UNCONTROLLED_CHANGES", this.clearSilentChangeWatcherTimeout); // ensure that backing values are up to date before the form is submitted

          formEmitter.on("PRE_SUBMIT", this.updateBackingValue.bind(this, true));
          formEmitter.on("UPDATED_MODEL_VALUE", function (e) {
            if (e.data.fieldName === _this2.props.fieldName) {
              _this2.value = _this2.readBackingValue(_this2.props, true);
            }
          });
        }

        if ((0, _isFunction.default)(this.didMount)) {
          this.didMount();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.clearSilentChangeWatcherTimeout();
        var formEmitter = this.formModel.emitter;

        if (formEmitter) {
          formEmitter.off("WATCH_FOR_UNCONTROLLED_CHANGES", this.setSilentChangeWatcherTimeout);
          formEmitter.off("STOP_WATCHING_FOR_UNCONTROLLED_CHANGES", this.clearSilentChangeWatcherTimeout);
          formEmitter.off("PRE_SUBMIT");
          formEmitter.off("UPDATED_MODEL_VALUE");
        }
      }
    }, {
      key: "formModel",
      get: function get() {
        return !(0, _isUndefined.default)(this.props.overrideForm) ? this.props.overrideForm : this.context.form;
      } // callback style ref, preferable to named refs

    }, {
      key: "setInputRef",
      value: function setInputRef(input) {
        this.inputElement = input;
      } // list props that should be passed to "native" html input

    }, {
      key: "getInnerInputProps",
      value: function getInnerInputProps() {
        var propNames = ["placeholder", "disabled", "autoComplete"];
        var innerProps = (0, _pick.default)(this.props, propNames); // for accessibility, if there's no label, try to use the placeholder text instead

        if (!this.props.label && this.props.placeholder) {
          innerProps["aria-label"] = this.props.placeholder;
        }

        return innerProps;
      }
    }, {
      key: "checkForUncontrolledChanges",
      value: function checkForUncontrolledChanges() {
        if (this.inputElement && this.props.outConverter(this.inputElement.value) !== this.value) {
          try {
            this.inputElement.dispatchEvent(new Event("change"));
          } catch (ex) {
            // IE (as of IE11) still doesn't support the Event constructor syntax
            var event = document.createEvent("Event");
            event.initEvent("change", true, true);
            this.inputElement.dispatchEvent(event);
          }
        }
      }
    }, {
      key: "readValue",
      value: function readValue() {
        var useObservable = this.focused || this.value === "" || !(0, _isEmpty.default)(this.getErrors());
        return useObservable ? this.value : this.props.blurConverter(this.value);
      }
    }, {
      key: "readBackingValue",
      value: function readBackingValue(props, skipErrors) {
        var value = this.formModel.data.get(props.fieldName);

        if (!(0, _isEmpty.default)(this.getErrors()) && skipErrors) {
          // use observable value if the backing value is invalid
          return this.value;
        }

        return (0, _isUndefined.default)(value) || (0, _isNull.default)(value) ? "" : props.inConverter(value);
      }
    }, {
      key: "updateBackingValue",
      value: function updateBackingValue(shouldValidate) {
        var value = this.value && typeof this.value.trim === "function" ? (0, _trim.default)(this.value) : this.value;
        value = value === "" ? null : value;
        value = this.props.outConverter(value);
        var fieldName = this.props.fieldName;
        this.formModel.data.set(fieldName, value);
      }
    }, {
      key: "handleChange",
      value: function handleChange(e) {
        if (!this.inputElement) {
          _clientErrorLogger.default.notify("No input element defined for form field", "error");

          return;
        }

        this.value = this.inputElement.value; // The input may already be changed at this point, but this makes sure that it is also validated.

        this.updateBackingValue();

        if ((0, _isFunction.default)(this.props.onChange)) {
          this.props.onChange(e);
        }
      }
    }, {
      key: "handleFocus",
      value: function handleFocus(e) {
        this.focused = true;
        this.formModel.emitter && this.formModel.emitter.emit("WATCH_FOR_UNCONTROLLED_CHANGES");

        if ((0, _isFunction.default)(this.props.onFocus)) {
          this.props.onFocus(e);
        }
      }
    }, {
      key: "handleBlur",
      value: function handleBlur(e) {
        this.formModel.emitter && this.formModel.emitter.emit("STOP_WATCHING_FOR_UNCONTROLLED_CHANGES");
        this.focused = false;
        this.formModel.markFieldDone(this.props.fieldName);

        if ((0, _isFunction.default)(this.props.onBlur)) {
          this.props.onBlur(e);
        }
      }
    }, {
      key: "setSilentChangeWatcherTimeout",
      value: function setSilentChangeWatcherTimeout() {
        this.clearSilentChangeWatcherTimeout(); // The actual changeTimeout will be used for the focused input.

        if (!this.focused) {
          this._watchForSilentChangesTimeout = setTimeout(function () {
            this.checkForUncontrolledChanges();
            this.setSilentChangeWatcherTimeout();
          }.bind(this), 300);
        }
      }
    }, {
      key: "clearSilentChangeWatcherTimeout",
      value: function clearSilentChangeWatcherTimeout() {
        if (this._watchForSilentChangesTimeout) {
          clearTimeout(this._watchForSilentChangesTimeout);
          this._watchForSilentChangesTimeout = undefined;
        }
      }
    }, {
      key: "getErrors",
      value: function getErrors() {
        return this.formModel.errors.get(this.props.fieldName);
      }
    }, {
      key: "renderErrors",
      value: function renderErrors() {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "error-message-container"
        }, this.props.showErrors && /*#__PURE__*/_react.default.createElement(_CustomError.default, {
          errors: this.getErrors()
        }));
      }
    }, {
      key: "getClassNames",
      value: function getClassNames(additionalClassNames) {
        var classes = {
          "input-container": true,
          "has-errors": this.props.showErrors && this.getErrors(),
          disabled: this.props.disabled
        };

        if (this.props.className) {
          classes[this.props.className] = true;
        }

        if ((0, _isArray.default)(additionalClassNames)) {
          (0, _forEach.default)(additionalClassNames, function (name) {
            classes[name] = true;
          });
          return (0, _classnames.default)(classes);
        } else if (_typeof(additionalClassNames) === "object") {
          return (0, _classnames.default)((0, _extend.default)(classes, additionalClassNames));
        } else {
          return (0, _classnames.default)(classes) + " " + additionalClassNames;
        }
      }
    }]);

    return _class;
  }(superclass), _defineProperty(_class2, "contextType", _CustomForm.CustomFormContext), _defineProperty(_class2, "propTypes", (0, _extend.default)({}, {
    fieldName: _propTypes.default.string.isRequired,
    id: _propTypes.default.string,
    name: _propTypes.default.string,
    // inConverter: convert storage value into input value
    inConverter: _propTypes.default.func,
    // outConverter: format input value to storage
    outConverter: _propTypes.default.func,
    // blurConverter: format the output of inConverter for blurred display (note: this differs from FormFieldMixin)
    blurConverter: _propTypes.default.func,
    // event hooks
    onChange: _propTypes.default.func,
    onFocus: _propTypes.default.func,
    onBlur: _propTypes.default.func,
    overrideForm: _propTypes.default.object,
    showErrors: _propTypes.default.bool,
    autoComplete: _propTypes.default.oneOf(["on", "off"])
  }, superclass.propTypes)), _defineProperty(_class2, "defaultProps", (0, _extend.default)({}, {
    // Since all these values are going to end up on inputs, we need to coerce
    // them to strings in order to compare the backing model value against the
    // rendered element value (this.inputElement, set via setInputRef)
    inConverter: function inConverter(value) {
      return (value || value === 0) && value.toString ? (0, _trim.default)(value.toString()) : "";
    },
    outConverter: function outConverter(value) {
      return value && typeof value.trim === "function" ? (0, _trim.default)(value) : value;
    },
    blurConverter: function blurConverter(value) {
      return value;
    },
    showErrors: true,
    autoComplete: "on"
  }, superclass.defaultProps)), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "focused", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "value", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "setInputRef", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "setInputRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getInnerInputProps", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "getInnerInputProps"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkForUncontrolledChanges", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "checkForUncontrolledChanges"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "readValue", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "readValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "readBackingValue", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "readBackingValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateBackingValue", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "updateBackingValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleChange", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleFocus", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleFocus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleBlur", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleBlur"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSilentChangeWatcherTimeout", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "setSilentChangeWatcherTimeout"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearSilentChangeWatcherTimeout", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "clearSilentChangeWatcherTimeout"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getErrors", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "getErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "renderErrors", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "renderErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getClassNames", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "getClassNames"), _class.prototype)), _class));
};

var _default = FormField;
exports.default = _default;